import React from 'react';
import { thumbFileUrl, previewFileUrl } from './mediaFileUrl';

// Same shape as the marketing-primary thumbnail on the Pricelist Catalog
// Report (PricelistExtendedReport.js). Shared by the Products list and the
// Edit Product form, sized via `size` and pointed at the right generated
// derivative via `variant` ('thumb' for the list's small box, 'preview' for
// the Edit form's bigger one) — see mediaImageStorage.js for how those are
// generated.
export function PlaceholderThumb({ size = 42 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 72 72" style={{ display: 'block', margin: '0 auto' }}>
      <rect x="1" y="1" width="70" height="70" rx="10" fill="#f6f8fa" stroke="#cdd5df" strokeWidth="3" />
      <circle cx="26" cy="26" r="7" fill="#cdd5df" />
      <path d="M8 54 L28 34 L40 46 L50 36 L64 54 Z" fill="#cdd5df" />
    </svg>
  );
}

// Same box/stroke treatment as PlaceholderThumb, but a head-and-shoulders
// silhouette instead of the image-mountain glyph — used wherever a row
// represents a person (CommercialEntity/Customer type === 'individual')
// rather than a product or an organisation, so an unset thumbnail still
// reads as "no photo of a person" rather than "no product image".
export function PersonPlaceholderThumb({ size = 42 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 72 72" style={{ display: 'block', margin: '0 auto' }}>
      <rect x="1" y="1" width="70" height="70" rx="10" fill="#f6f8fa" stroke="#cdd5df" strokeWidth="3" />
      <circle cx="36" cy="28" r="12" fill="#cdd5df" />
      <path d="M14 60 C14 44 24 38 36 38 C48 38 58 44 58 60 Z" fill="#cdd5df" />
    </svg>
  );
}

// entry: the { media_image_id, ... } row from GET /api/media-images/
// primary-for-products, or null/undefined for "no primary marketing image
// set yet" — renders the placeholder either way, rather than a browser
// broken-image icon.
export function ProductThumb({ entry, size = 42, variant = 'thumb' }) {
  if (!entry) return <PlaceholderThumb size={size} />;
  const url = variant === 'preview' ? previewFileUrl(entry.media_image_id) : thumbFileUrl(entry.media_image_id);
  return (
    <img
      src={url}
      alt=""
      width={size}
      height={size}
      style={{ display: 'block', margin: '0 auto', objectFit: 'contain', borderRadius: 4, border: '1px solid #cdd5df', background: '#f6f8fa' }}
    />
  );
}
